const DATA = /^\d{4}-\d{2}-\d{2}$/;
export const LIMITE_CONSULTA = 10;

function dataConsulta(valor) {
  const texto = String(valor || "").trim();
  return DATA.test(texto) ? texto : "";
}

export function consultaParaQuery(filtro, page, limit) {
  const limite = Number(limit);
  const params = {
    page: page > 0 ? page : 1,
    limit: limite >= 1 && limite <= 100 ? limite : LIMITE_CONSULTA
  };
  const origem = filtro || {};
  const dataInicio = dataConsulta(origem.dataInicio);
  const dataFim = dataConsulta(origem.dataFim);
  const numpedido = String(origem.numpedido || "").trim();
  const produto = String(origem.produto || "").trim();
  if (dataInicio) {
    params.dataInicio = dataInicio;
  }
  if (dataFim) {
    params.dataFim = dataFim;
  }
  if (numpedido) {
    params.numpedido = numpedido;
  }
  if (origem.canal === "COMPRAS" || origem.canal === "VENDAS") {
    params.canal = origem.canal;
  }
  if (produto) {
    params.search = produto;
  }
  return params;
}
